export function MessageRejectIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M4.99981 4.5L7.49981 7M7.49981 4.5L4.99981 7M6.24981 10C8.59702 10 10.4998 8.09721 10.4998 5.75C10.4998 3.40279 8.59702 1.5 6.24981 1.5C3.9026 1.5 1.99981 3.40279 1.99981 5.75C1.99981 6.225 2.07774 6.6818 2.2215 7.10831C2.2756 7.26881 2.30265 7.34906 2.30753 7.41071C2.31234 7.4716 2.3087 7.51429 2.29364 7.57347C2.27839 7.63341 2.24471 7.69574 2.17736 7.82041L1.35953 9.33418C1.24287 9.5501 1.18455 9.65806 1.1976 9.74139C1.20897 9.81396 1.25169 9.87786 1.3144 9.91612C1.3864 9.96004 1.50846 9.94742 1.75258 9.92219L4.31309 9.65751C4.39063 9.64949 4.4294 9.64548 4.46474 9.64684C4.4995 9.64816 4.52403 9.65143 4.55793 9.65924C4.59239 9.66718 4.63572 9.68388 4.72239 9.71727C5.19642 9.89989 5.71142 10 6.24981 10Z'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
